import { useRef } from "react";
import { toast } from "react-toastify";
import api from "../../Utils/Axios";

// Custom hook for company profile handlers - same structure, no changes
export const useCompanyProfile = ({
  formData,
  setFormData,
  setIsSaving,
  setCompany,
  persons,
  getToken
}) => {
  const formDataRef = useRef(formData);
  const personsRef = useRef(persons);
  formDataRef.current = formData;
  personsRef.current = persons;

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Save profile
  const handleSaveProfile = async (e) => {
    e.preventDefault();
    try {
      setIsSaving(true);
      const token = getToken();
      const fd = formDataRef.current;
      const payload = {
        ...fd,
        persons: personsRef.current
      };
      if (fd.billItemOptions !== undefined) {
        payload.billItemOptions = Array.isArray(fd.billItemOptions) ? fd.billItemOptions : [];
      }
      if (fd.billItemFormMode !== undefined) {
        payload.billItemFormMode = fd.billItemFormMode === 'static' ? 'static' : 'list';
        payload.billFormStaticItemName = fd.billFormStaticItemName != null ? String(fd.billFormStaticItemName) : '';
        payload.billFormStaticUnit = fd.billFormStaticUnit != null ? String(fd.billFormStaticUnit) : '';
      }
      const response = await api.put(
        "/company/profile",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      
      toast.success("Profile updated successfully!");
      const updated = response.data.company;
      setCompany((prev) => {
        const merged = { ...(prev || {}), ...updated };
        try {
          localStorage.setItem("companyData", JSON.stringify(merged));
        } catch (_) {
          /* ignore quota / private mode */
        }
        return merged;
      });
      if (updated) {
        setFormData((fd) => {
          const next = { ...fd };
          if (Array.isArray(updated.billItemOptions) && fd.billItemOptions !== undefined) {
            next.billItemOptions = updated.billItemOptions;
          }
          if (updated.billItemFormMode !== undefined && fd.billItemFormMode !== undefined) {
            next.billItemFormMode = String(updated.billItemFormMode).toLowerCase() === 'static' ? 'static' : 'list';
          }
          if (updated.billFormStaticItemName !== undefined && fd.billFormStaticItemName !== undefined) {
            next.billFormStaticItemName = updated.billFormStaticItemName || '';
          }
          if (updated.billFormStaticUnit !== undefined && fd.billFormStaticUnit !== undefined) {
            next.billFormStaticUnit = updated.billFormStaticUnit || '';
          }
          return next;
        });
      }
    } catch (error) {
      console.error("Update profile error:", error);
      toast.error(error.response?.data?.message || "Failed to update profile");
    } finally {
      setIsSaving(false);
    }
  };

  return {
    handleChange,
    handleSaveProfile
  };
};

